import html2canvas, { Options } from 'html2canvas';
import { saveAs } from 'file-saver';

export const exportAsImage = async (element: HTMLElement, fileName: string, options?: Partial<Options>) => {
  const canvas = await html2canvas(element, options);
  const image = canvas.toDataURL('image/jpeg', 0.8);

  saveAs(image, fileName);
};
